const apiKey = process.env.NEXT_PUBLIC_GEOCODE_API_KEY as string;

type Props = Pick<ImEventDto, 'latitude' | 'longitude'>;

export const GeoMap: React.FC<Props> = ({ latitude, longitude }) => {
  const src = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${latitude},${longitude}&zoom=${17}`;
  return (
    <iframe
      width="100%"
      height="400"
      style={{ border: 0 }}
      loading="lazy"
      allowFullScreen
      src={src}
    ></iframe>
  );
};
